module.exports = __webpack_public_path__ + "distribution/img/shouyetishi.02ee960c.png";